import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchAdminCollectionWishes } from '@/services/admin';

/** Пожелания коллекций от пользователей: только текст и дата, без того, кто написал. */
export function CollectionWishesAdmin() {
  const { status, session } = useAuthSession();
  const token = session?.access_token ?? '';

  const wishes = useQuery({
    queryKey: ['admin', 'collection-wishes'],
    queryFn: () => fetchAdminCollectionWishes(token),
    enabled: status === 'ready' && Boolean(session),
    retry: false,
  });

  return (
    <section aria-label="Пожелания коллекций" className="flex flex-col gap-3">
      <h2 className="text-lg font-semibold text-text">Пожелания коллекций</h2>

      {wishes.isPending && <p className="text-text-2">Загрузка…</p>}
      {wishes.isError && <p className="text-danger">Не удалось загрузить пожелания. Обновите страницу.</p>}
      {wishes.data?.wishes.length === 0 && <p className="text-sm text-text-2">Пожеланий пока нет.</p>}

      <ul className="flex flex-col gap-2">
        {wishes.data?.wishes.map((wish) => (
          <li key={wish.id} className="rounded-card border border-border px-3 py-2 text-sm">
            <p className="whitespace-pre-line text-text">{wish.body}</p>
            <p className="text-text-3">{new Date(wish.createdAt).toLocaleString('ru-RU')}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
